"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xmlSafeText = void 0;
// Control codes XML 1.0 forbids (below U+0020 except tab, LF, CR; U+FFFE and
// U+FFFF; unpaired surrogates). One in a copy-pasted title would make the
// whole file unreadable to a vendor's parser, so each becomes a space.
// Visible characters (𠮷, 髙, ①, emoji, &) are never touched.
// eslint-disable-next-line no-control-regex
const XML_ILLEGAL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g;
const xmlSafeText = (text) => text.replace(XML_ILLEGAL, ' ');
exports.xmlSafeText = xmlSafeText;
